import { setReadOnly, setAlive, setDisable, setNone, setCondition, resetCondition } from "./elementAccessFunctions";
const table = {};

function workCondition(element) {
  if (!element) {
    return
  }
  switch (element.stateStatus) {
    case "ALIVE":
      return setAlive(element);
    case "DISABLE":
      return setDisable(element);
    case "NONE":
      return setNone(element);
    case "READONLY":
      return setReadOnly(element);
  }
}

const accessMixin = {
  directives: {
    "access-role": {
      mounted: function (element, binding, vnode) {
        let elemName = binding.value.name;
        let me = binding.value.me;

        let pageName = me.$route.name.split("-create")[0];
        let page = table[pageName];

        if (!page) {
          return;
        }

        if (typeof page == "string") {
          page = table[page];
        }

        let elemRef = page[elemName];
        if (!elemRef) return;
        let item = JSON.parse(localStorage.getItem("userRole"));
        let role = item && item.systemName ? item.systemName : null;
        let condition = elemRef[role] ? elemRef[role] : "ALIVE";
        setCondition(element, condition);
        workCondition(element);
      },
    },
  },
  data() {
    return {
      mixinLoadingAccess: false
    }
  },
  methods: {
    clearAllCondition() {
      Object.keys(this.$refs).forEach((elem) => resetCondition(this.$refs[elem]));
    },
    resetCondition(refs = [], cond = "ALIVE") {
      refs.forEach((elem) => {
        resetCondition(this.$refs[elem], cond);
        workCondition(this.$refs[elem]);
      });
    },
    mountAccess(area, needCheckAdjustment, needCheckOrderStatus) {
      this.mixinLoadingAccess = true;
      if (this.refsForCheckInMixin && this.refsForCheckInMixin.length > 0) {
        let areaName = area || this.$route.name.split("-create")[0];
        this.startMountAccess(areaName, needCheckAdjustment, needCheckOrderStatus);
      } else {
        this.mixinLoadingAccess = false;
      }
    },
    async loadRoleAccess(area) {
      let areaName = area || this.$route.name.split("-create")[0];
      return await this.$store.dispatch("securityRoleAccess/load", areaName)
    },
    loadLocalRoleAccess(area) {
      let areaName = area || this.$route.name.split("-create")[0];
      this.$store
        .dispatch("securityRoleAccess/getAccess", areaName)
        .then((result) => {
          this.localAccess = [result];
        });
    },
    checkAdjustmentMode() {
      return this.adjustmentMode;
    },
    checkCreator(model) {
      return model && this.userinfo && (!model.id || model.createdBy === this.userinfo.code);
    },
    checkFormAccess(model) {
      return this.checkAccess("edit-option", model);
    },
    checkDeleteAccess() {
      return this.checkAccess("deleted-fastFilter");
    },
    checkAccess(elem, model, needCheckAdjustment) {
      return this.checkRoleAccess(elem, model, this.access, needCheckAdjustment);
    },
    checkLocalAccess(elem, model, needCheckAdjustment) {
      return this.checkRoleAccess(elem, model, this.localAccess, needCheckAdjustment);
    },
    checkRoleAccess(elem, model, access, needCheckAdjustment = false, needCheckOrderStatus = false) {
      let isAccess = false;
      if (access) {
        let element = access[0] ? access[0][elem] : null;
        if (element) {
          let roleModel = JSON.parse(localStorage.getItem("userRole"));
          let role =
            roleModel && roleModel.systemName ? roleModel.systemName : null;
          if(element[role]) {
            if(needCheckAdjustment && element[role].includes("_AND_")) {
              let mode = "EDITMODE";

              if (needCheckOrderStatus) {
                mode = this.checkAdjustmentMode() ? `ADJUSTMENT${this.orderStatus.toUpperCase()}MODE`: mode;
              }
              else {
                mode = this.checkAdjustmentMode() ? `ADJUSTMENTMODE`: mode;
              }
              
              if (!element[role].includes(mode))
                isAccess = true;
            }
          } else if (
            !element[role] ||
            (element[role].includes("CREATOR") && this.checkCreator(model))
          ) {
            isAccess = true;
          }
        }
      }
      return isAccess;
    },
    wrapperCheckRoles(elemsList, model) {
      let res = elemsList.filter((elem) => {
        if (this.access) {
          let element = this.access[0] ? this.access[0][elem.liteRef] : null;
          let exclude = false;
          if (element) {
            let item = JSON.parse(localStorage.getItem("userRole"));
            let role = item && item.systemName ? item.systemName : null;
            if (
              element[role] == "NONE" ||
              (element[role] == "CREATOR_OR_NONE" && !this.checkCreator(model))
            ) {
              exclude = true;
              return false;
            }
          }
          return !exclude;
        }
      });
      return res;
    },
    startMountAccess(area, needCheckAdjustment, needCheckOrderStatus) {
      let checked = 0;
      const limitLoader = 10
      const interval = setInterval(() => {
        let allRefsReady = this.refsForCheckInMixin.every((elem) => {
          return Boolean(this.$refs[elem]);
        });
        if (allRefsReady && checked >= limitLoader) {
          this.setAccess(area, needCheckAdjustment, needCheckOrderStatus);
          clearInterval(interval);
        }
        checked++;
      }, 100);
    },
    setAccess(area, needCheckAdjustment, needCheckOrderStatus) {
      this.$store.getters;
      let item = JSON.parse(localStorage.getItem("userRole"));
      let role = item && item.systemName ? item.systemName : null;
      let refs = this.$refs;
      let me = this;
      this.$store
        .dispatch("securityRoleAccess/getAccess", area)
        .then((result) => {
          // CIRCLE BY REFS
          Object.keys(me.$refs).forEach((elem) => {
            if (result && result[elem]) {
              let elemAccesses = result[elem];
              let condition = this.getCondition(elemAccesses, role, needCheckAdjustment, needCheckOrderStatus);
              let element = refs[elem] instanceof Array ? refs[elem][0] : refs[elem];
              if(element) {
                setCondition(element, condition);
                workCondition(element);
              }
            }
          });
          this.mixinLoadingAccess = false;
        });
    },
    getCondition(elemAccesses, role, needCheckAdjustment, needCheckOrderStatus) {
      let condition = "ALIVE";

      if (elemAccesses && elemAccesses[role]) {
        if(needCheckAdjustment && elemAccesses[role].includes("_AND_")) {
          let mode = "EDITMODE";

          if (needCheckOrderStatus) {
            mode = this.checkAdjustmentMode() ? `ADJUSTMENT${this.orderStatus.toUpperCase()}MODE`: mode;
          }
          else {
            mode = this.checkAdjustmentMode() ? `ADJUSTMENTMODE`: mode;
          }

          if (elemAccesses[role].includes(mode))
            condition = elemAccesses[role].split("_AND_").pop();
        } else if (
          !(elemAccesses[role].includes("CREATOR") && this.checkCreator(this.model))
        ) {
          condition = elemAccesses[role].includes("CREATOR")
            ? elemAccesses[role].split("_OR_")[1]
            : elemAccesses[role];
        }
      }

      return condition;
    },
  },
};

export default accessMixin;
